import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFilterCircle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"filter-circle, sort"} maskId="square-filled-radius-0-stroke-1-IconFilterCircle"><path fillRule="evenodd" clipRule="evenodd" d="M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM8 12V13H16V12H8ZM6 9H18V10H6V9ZM10 15V16H14V15H10Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconFilterCircle;
